
import { CTAdminBreadcrumbs } from '../components/breadcrumbs/CTAdminBreadcrumbs';
import Dashboard, { DashboardRow, DashboardSection } from '@g17eco/molecules/dashboard';
import { DefaultSurveyConfig } from '@features/company-settings';
import { useAppSelector } from '@reducers/index';
import { currentInitiative } from '@selectors/initiative';
import { BlockingLoader } from '@g17eco/atoms/loader/BlockingLoader';

export const ReportSettingsRoute = () => {

  const initiative = useAppSelector(currentInitiative);
  if (!initiative) {
    return <BlockingLoader />
  }

  return (
    <Dashboard>
      <DashboardRow>
        <CTAdminBreadcrumbs breadcrumbs={[{ label: 'Report Settings' }]} initiativeId={initiative._id} />
      </DashboardRow>
      <DashboardRow>
        <h3 className='pl-2'>Report settings</h3>
      </DashboardRow>
      <DashboardSection>
        <DefaultSurveyConfig />
      </DashboardSection>
    </Dashboard>
  );
};
